import PropTypes from 'prop-types'
import { useConnectField } from 'react-bfm'
import { Autocomplete } from '@mui/material'

// onChange get Date object instead of event
const transformEventToValue = (_, value) => value

const ConnectedAutocomplete = (props) => {
  const fieldProps = useConnectField({ transformEventToValue, ...props }, [
    'error',
    'touched',
    'dirty',
    'focus',
    'valid',
  ])

  return <Autocomplete {...fieldProps} />
}

ConnectedAutocomplete.propTypes = {
  namespace: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
}

export default ConnectedAutocomplete
